import React, { useEffect, useState } from "react";

function Admin() {
  const [questions, setQuestions] = useState([]);
  const [enunciado, setEnunciado] = useState("");
  const [alternativas, setAlternativas] = useState(["", "", "", ""]);
  const [correta, setCorreta] = useState(0);
  const [mensagem, setMensagem] = useState("");
  const [editId, setEditId] = useState(null);

  const token = localStorage.getItem("token");

  const loadQuestions = async () => {
    const res = await fetch("http://168.231.95.244:3000/api/questions", {
      headers: { Authorization: `Bearer ${token}` },
    });
    const data = await res.json();
    setQuestions(data);
  };

  useEffect(() => {
    loadQuestions();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = { enunciado, alternativas, correta: parseInt(correta) };
    const url = editId
      ? `http://168.231.95.244:3000/api/questions/${editId}`
      : "http://168.231.95.244:3000/api/questions";
    const method = editId ? "PUT" : "POST";

    const res = await fetch(url, {
      method,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });

    const data = await res.json();
    setMensagem(data.message || "Sucesso!");
    setEnunciado("");
    setAlternativas(["", "", "", ""]);
    setCorreta(0);
    setEditId(null);
    loadQuestions();
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Deseja realmente deletar essa questão?")) return;
    await fetch(`http://simulado_backend:3000/api/questions/${id}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${token}` },
    });
    loadQuestions();
  };

  const handleEdit = (q) => {
    setEditId(q.id);
    setEnunciado(q.enunciado);
    setAlternativas(q.alternativas);
    setCorreta(q.correta);
  };

  const handleAlternativaChange = (index, value) => {
    const novas = [...alternativas];
    novas[index] = value;
    setAlternativas(novas);
  };

  return (
    <div className="container">
      <h1>Painel Administrativo</h1>

      <form onSubmit={handleSubmit}>
        <div>
          <label>Enunciado:</label>
          <textarea
            value={enunciado}
            onChange={(e) => setEnunciado(e.target.value)}
            required
          />
        </div>

        <div>
          <label>Alternativas:</label>
          {alternativas.map((alt, idx) => (
            <input
              key={idx}
              type="text"
              placeholder={`Alternativa ${idx + 1}`}
              value={alt}
              onChange={(e) => handleAlternativaChange(idx, e.target.value)}
              required
            />
          ))}
        </div>

        <div>
          <label>Índice da correta (0-3):</label>
          <input
            type="number"
            value={correta}
            min="0"
            max="3"
            onChange={(e) => setCorreta(e.target.value)}
          />
        </div>

        <button type="submit">{editId ? "Atualizar" : "Adicionar"} Questão</button>
      </form>

      {mensagem && <p>{mensagem}</p>}

      <hr />

      <h2>Questões existentes</h2>
      <ul>
        {questions.map((q) => (
          <li key={q.id}>
            <strong>{q.enunciado}</strong> (correta: {q.correta})
            <button onClick={() => handleEdit(q)}>Editar</button>
            <button onClick={() => handleDelete(q.id)}>Deletar</button>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default Admin;
